export const IS_LOGGED_IN = 'isLoggedIn';

export enum AUTH_FAIL_CODE {
  TENANT_ACCESS_DENIED = 'TENANT_ACCESS_DENIED',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  INVALID_GOOGLE_USER_INFO = 'INVALID_GOOGLE_USER_INFO',
}
